import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type OrganizationPerson} from './model';

const domain = 'ENTITIES/ORGANIZATION_PERSONS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (organizationId: string, organizationPersonId: string) => ({organizationId, organizationPersonId}),
    person => ({person}),
);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    (organizationId: string) => ({organizationId}),
    (persons: OrganizationPerson[]) => ({persons}),
);

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(
    `${domain}/CREATE`,
    (person: OrganizationPerson) => ({person}),
    (person: OrganizationPerson) => ({person}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (oldPerson: OrganizationPerson, newPerson: OrganizationPerson) => ({oldPerson, newPerson}),
    (oldPerson: OrganizationPerson, newPerson: OrganizationPerson) => ({oldPerson, newPerson}),
);

export const {
    action: deletePerson,
    success: deletePersonSuccess,
    failed: deletePersonFailed,
    aborted: deletePersonAborted,
} = createAction(
    `${domain}/DELETE`,
    (person: OrganizationPerson) => ({person}),
    (person: OrganizationPerson) => ({person}),
);
